/* Official PayPal Messages only; checkout continues to use Shopify payments.
   Public SDK account parameters copied from this theme's Pay Later embed, 2026-11-02. */
(() => {
  if (window.MPPayLater) return;
  const selector = '[data-mp-paypal-message], [data-campaign-paypal]';
  const sdkUrl = 'https://www.paypal.com/sdk/js?client-id=AbtXlp5R3xc83T9xW_ZXKTK8IVZ-14EMelDioU4VC285IqSuxUI4yotKxjV0sz_X6YsONYi10vSBPNKM&merchant-id=254QJ8VRL8GXY&components=messages';
  let sdkPromise;
  const pending = new WeakMap();
  const rendered = new WeakSet();
  const loadSDK = () => {
    if (window.PayPalSDK?.Messages) return Promise.resolve(window.PayPalSDK);
    if (sdkPromise) return sdkPromise;
    sdkPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = sdkUrl;
      script.async = true;
      script.dataset.namespace = 'PayPalSDK';
      script.dataset.partnerAttributionId = 'JADEDPIXEL_SHOPPINGCART_EC_CA';
      script.addEventListener('load', () => {
        if (window.PayPalSDK?.Messages) resolve(window.PayPalSDK);
        else { sdkPromise = null; script.remove(); reject(new Error('PayPal Messages unavailable')); }
      }, { once: true });
      script.addEventListener('error', () => {
        sdkPromise = null;
        script.remove();
        reject(new Error('PayPal Messages unavailable'));
      }, { once: true });
      document.head.append(script);
    });
    return sdkPromise;
  };
  const render = node => {
    if (!node?.isConnected || rendered.has(node) || node.closest('[hidden]')) return Promise.resolve();
    if (pending.has(node)) return pending.get(node);
    const task = loadSDK().then(sdk => {
      if (!node.isConnected || node.closest('[hidden]')) return;
      const amount = Number(node.dataset.ppAmount);
      if (!Number.isFinite(amount) || amount <= 0) return;
      return sdk.Messages({
        amount,
        currency: node.dataset.ppCurrency || 'EUR',
        pageType: node.matches('[data-campaign-paypal]') ? 'product-listing' : 'product-details',
        style: { layout: 'text', logo: { type: 'inline' }, text: { size: Number(node.dataset.ppStyleTextSize) || 12, color: 'black' } }
      }).render(node).then(() => {
        rendered.add(node);
        observer?.unobserve(node);
        const parent = node.closest('[data-campaign-finance], [data-mp-paypal-pay-later]');
        const fallback = parent?.querySelector('[data-finance-fallback], [data-mp-paypal-fallback]');
        if (fallback && node.querySelector('iframe')) fallback.hidden = true;
      });
    }).catch(() => { /* The existing PayPal information link remains available. */ })
      .finally(() => pending.delete(node));
    pending.set(node, task);
    return task;
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) render(entry.target); });
  }, { rootMargin: '100px 0px' }) : null;
  const scan = (scope = document) => {
    scope.querySelectorAll(selector).forEach(node => {
      if (observer) observer.observe(node);
      else render(node);
    });
  };
  window.MPPayLater = { scan, render };
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('focusin', event => {
    const parent = event.target.closest?.('[data-mp-paypal-pay-later], [data-campaign-finance]');
    if (parent) render(parent.querySelector(selector));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();
})();
